/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Youtube_ExportInputs */

const cs_enum_youtube_export = /** @type {(inputs: Enum_Youtube_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na YouTube`)
};

const en_enum_youtube_export = /** @type {(inputs: Enum_Youtube_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube export`)
};

/**
* | output |
* | --- |
* | "YouTube export" |
*
* @param {Enum_Youtube_ExportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_youtube_export = /** @type {((inputs?: Enum_Youtube_ExportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Youtube_ExportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_youtube_export(inputs)
	return cs_enum_youtube_export(inputs)
});